/**
 * Types pour les réponses backend communes
 */

/**
 * Type pour les réponses d'erreur du backend
 */
export interface BackendError {
  erreur: string;
  bloqueJusquA?: number;
}

/**
 * Résultat d'une query/mutation qui peut échouer
 */
export type BackendResult<T> = T | BackendError;

/**
 * Type guard pour vérifier si c'est une erreur
 */
export function isBackendError(result: unknown): result is BackendError {
  return (
    typeof result === "object" &&
    result !== null &&
    "erreur" in result &&
    typeof (result as BackendError).erreur === "string"
  );
}
